import { onBroadcastEvent, registerEvent, unRegisterEvent } from './broadcast-event';

export default {
  onBroadcastEvent,
  registerEvent,
  unRegisterEvent,
};
